(() => {
  const TREEDIUM_DEBUG = false;
  function treediumLog(...args) {
    if (TREEDIUM_DEBUG) console.log(...args);
  }
  function treediumWarn(...args) {
    if (TREEDIUM_DEBUG) console.warn(...args);
  }

  const blocks = document.querySelectorAll("[data-treedium-root]");
  const MESSAGE_TYPE_ADD = "TREEDIUM_ADD_TO_CART";
  const MESSAGE_TYPE_ADD_RESULT = "TREEDIUM_ADD_TO_CART_RESULT";
  const MESSAGE_TYPE_CLOSE = "TREEDIUM_CLOSE";
  const MESSAGE_TYPE_CLEAN_URL = "TREEDIUM_CLEAN_URL";
  const MESSAGE_TYPE_SHARE_REQUEST = "TREEDIUM_CREATE_SHARE_URL";
  const MESSAGE_TYPE_SHARE_RESPONSE = "TREEDIUM_SHARE_URL_RESULT";
  const MESSAGE_TYPE_INIT = "TREEDIUM_INIT_CONFIG";
  const MESSAGE_TYPE_READY = "TREEDIUM_READY";
  const MESSAGE_TYPE_ANALYTICS_CONSENT = "TREEDIUM_ANALYTICS_CONSENT";
  const MESSAGE_TYPE_ANALYTICS_CONSENT_REQUEST = "TREEDIUM_ANALYTICS_CONSENT_REQUEST";
  const DRAWER_SECTION_IDS = [
    "cart-icon-bubble",
    "cart-drawer",
    "main-cart-items",
    "cart-footer",
    "cart-live-region-text",
  ];
  const NOTIFICATION_SECTION_IDS = [
    "cart-icon-bubble",
    "cart-notification-product",
    "cart-notification-button",
  ];
  const PREVIEW_URL_PATTERN = /https:\/\/res\.cloudinary\.com\/[^\s<>"']+/g;
  const PREVIEW_URL_TEST_PATTERN = /https:\/\/res\.cloudinary\.com\/[^\s<>"']+/;
  const CART_PREVIEW_ROOT_SELECTORS = [
    "cart-drawer",
    "cart-notification",
    "main-cart-items",
    "#main-cart-items",
    ".cart-items",
    ".cart__items",
    'form[action*="/cart"]',
  ];
  const PRODUCT_FAMILY_HANDLES = [
    { modelKey: "adventurer", size: "945ml", handle: "dozze-adventurer-water-bottle-945ml" },
    { modelKey: "voyager", size: "620ml", handle: "dozze-voyager-water-bottle-620ml" },
    { modelKey: "cruiser", size: "530ml", handle: "dozze-cruiser-water-bottle-530ml" },
    { modelKey: "seeker", size: "592ml", handle: "dozze-seeker-tumbler-592ml" },
    { modelKey: "seeker", size: "355ml", handle: "dozze-seeker-tumbler-355ml" },
    { modelKey: "roamer", size: "887ml", handle: "dozze-roamer-tumbler-887ml" },
    { modelKey: "explorer", size: "592ml", handle: "black-edition-dozze-explorer-tumbler-variant-trial" },
    { modelKey: "wander", size: "296ml", handle: "dozze-wander-tumbler-296ml" },
    { modelKey: "kids", size: "530ml", handle: "dozze-kids-water-bottle-530ml" },
    { modelKey: "kids", size: "355ml", handle: "dozze-kids-water-bottle-355ml" },
    { modelKey: "food-jar", size: "592ml", handle: "dozze-food-jar" },
    { modelKey: "adventurer-matching-lid", size: "945ml", handle: "monochrome-edition-adventurer-water-bottle-945ml" },
    { modelKey: "voyager-matching-lid", size: "620ml", handle: "monochrome-edition-voyager-water-bottle-620ml" },
    { modelKey: "cruiser-matching-lid", size: "530ml", handle: "monochrome-edition-cruiser-water-bottle-530ml" },
    { modelKey: "seeker-matching-lid", size: "592ml", handle: "dozze-seeker-tumbler-592ml-monochrome-edition" },
    { modelKey: "kids-matching-lid", size: "530ml", handle: "kids-water-bottles-530ml-copy" },
  ];
  const PERSONALIZATION_PRODUCT_FALLBACK_HANDLES = [
    "item-personalization-3",
    "item-personalization",
    "item-personalization-2",
  ];
  const productConfigPromiseCache = new Map();
  let didAutoOpenSharedConfigurator = false;
  const MODAL_Z_INDEX = 2147483647;
  const SHOPIFY_CHAT_SUPPRESSED_Z_INDEX = String(MODAL_Z_INDEX - 2);
  const SHOPIFY_CHAT_MATCHERS = [
    "shopifychat",
    "shopify-chat",
    "shopify_chat",
    "shopify inbox",
    "shopify-inbox",
    "shopify_inbox",
    "inbox.shopify",
    "online store chat",
    "dummy-chat-button",
    "chat-button",
    "chat button",
    "chat-widget",
    "chat widget",
    "chat-launcher",
    "chat launcher",
  ];
  let shopifyChatSuppressionObserver = null;
  let shopifyChatSuppressionRaf = null;
  const suppressedShopifyChatElements = [];

  function getElementAttributeText(element) {
    if (!element || typeof element.getAttributeNames !== "function") return "";
    return element
      .getAttributeNames()
      .map((name) => `${name} ${element.getAttribute(name) || ""}`)
      .join(" ")
      .toLowerCase();
  }

  function isLikelyShopifyChatElement(element) {
    if (!element || element.closest?.("[data-modal]")) return false;

    const attributeText = getElementAttributeText(element);
    if (SHOPIFY_CHAT_MATCHERS.some((matcher) => attributeText.includes(matcher))) return true;

    const computedStyle = window.getComputedStyle(element);
    const zIndex = Number.parseInt(computedStyle.zIndex, 10);
    return (
      element.tagName === "IFRAME" &&
      computedStyle.position === "fixed" &&
      Number.isFinite(zIndex) &&
      zIndex >= MODAL_Z_INDEX - 10
    );
  }

  function rememberShopifyChatElement(element) {
    if (!element || suppressedShopifyChatElements.some((entry) => entry.element === element)) return;
    suppressedShopifyChatElements.push({
      element,
      inlineZIndex: element.style.zIndex,
      inlineZIndexPriority: element.style.getPropertyPriority("z-index"),
    });
  }

  function lowerShopifyChatElement(element) {
    rememberShopifyChatElement(element);
    if (
      element.style.getPropertyValue("z-index") === SHOPIFY_CHAT_SUPPRESSED_Z_INDEX &&
      element.style.getPropertyPriority("z-index") === "important"
    ) {
      return;
    }
    element.style.setProperty("z-index", SHOPIFY_CHAT_SUPPRESSED_Z_INDEX, "important");
  }

  function lowerShopifyChatAncestors(element) {
    let current = element?.parentElement;
    let depth = 0;
    while (current && current !== document.body && depth < 4) {
      const computedStyle = window.getComputedStyle(current);
      const zIndex = Number.parseInt(computedStyle.zIndex, 10);
      if (
        ["fixed", "sticky", "absolute"].includes(computedStyle.position) ||
        (Number.isFinite(zIndex) && zIndex >= MODAL_Z_INDEX - 10)
      ) {
        lowerShopifyChatElement(current);
      }
      current = current.parentElement;
      depth += 1;
    }
  }

  function suppressShopifyChatEmbeds() {
    const candidates = document.querySelectorAll(
      [
        "iframe",
        "[id]",
        "[class]",
        "[title]",
        "[aria-label]",
        "[data-shopify]",
        "[data-testid]",
        "[role='button']",
      ].join(",")
    );

    candidates.forEach((candidate) => {
      if (!isLikelyShopifyChatElement(candidate)) return;
      lowerShopifyChatElement(candidate);
      lowerShopifyChatAncestors(candidate);
    });
  }

  function scheduleShopifyChatSuppression() {
    if (shopifyChatSuppressionRaf) window.cancelAnimationFrame(shopifyChatSuppressionRaf);
    shopifyChatSuppressionRaf = window.requestAnimationFrame(() => {
      shopifyChatSuppressionRaf = null;
      suppressShopifyChatEmbeds();
    });
  }

  function startShopifyChatSuppression() {
    suppressShopifyChatEmbeds();
    window.setTimeout(suppressShopifyChatEmbeds, 250);
    window.setTimeout(suppressShopifyChatEmbeds, 1000);

    if (shopifyChatSuppressionObserver || !document.body) return;
    shopifyChatSuppressionObserver = new MutationObserver(scheduleShopifyChatSuppression);
    shopifyChatSuppressionObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ["class", "id", "src", "style", "title", "aria-label"],
      childList: true,
      subtree: true,
    });
  }

  function stopShopifyChatSuppression() {
    if (shopifyChatSuppressionObserver) {
      shopifyChatSuppressionObserver.disconnect();
      shopifyChatSuppressionObserver = null;
    }
    if (shopifyChatSuppressionRaf) {
      window.cancelAnimationFrame(shopifyChatSuppressionRaf);
      shopifyChatSuppressionRaf = null;
    }

    while (suppressedShopifyChatElements.length) {
      const { element, inlineZIndex, inlineZIndexPriority } = suppressedShopifyChatElements.pop();
      if (!element?.style) continue;
      if (inlineZIndex) {
        element.style.setProperty("z-index", inlineZIndex, inlineZIndexPriority || "");
      } else {
        element.style.removeProperty("z-index");
      }
    }
  }

  function shopifyRoute(path) {
    const root = window.Shopify?.routes?.root || "/";
    return `${root.replace(/\/?$/, "/")}${path.replace(/^\/+/, "")}`;
  }

  function cartRoute(key, fallbackPath) {
    return window.theme?.routes?.[key] || shopifyRoute(fallbackPath);
  }

  function getSharedConfigIdFromPage() {
    const params = new URLSearchParams(window.location.search);
    return params.get("treedium_config") || params.get("arConfig") || "";
  }

  function shouldAutoOpenConfigurator() {
    const params = new URLSearchParams(window.location.search);
    return params.get("open_configurator") === "1" || Boolean(params.get("treedium_config"));
  }

  function buildConfiguratorIframeUrl(iframeUrl) {
    const sharedConfigId = getSharedConfigIdFromPage();
    if (!sharedConfigId) return iframeUrl;

    try {
      const url = new URL(iframeUrl, window.location.origin);
      const pageParams = new URLSearchParams(window.location.search);
      const sharedModelKey = String(pageParams.get("treedium_model") || "")
        .toLowerCase()
        .trim()
        .replace(/&/g, "and")
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
      const sharedSize = String(pageParams.get("treedium_size") || "")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "");
      if (sharedModelKey) {
        const presetSlug = [sharedModelKey, sharedSize].filter(Boolean).join("-");
        const basePath = url.pathname.replace(/\/+$/, "");
        url.pathname = `${basePath}/${presetSlug}`.replace(/\/{2,}/g, "/");
      }
      url.searchParams.set("arConfig", sharedConfigId);
      return url.toString();
    } catch (error) {
      treediumWarn("[Treedium Shopify] could not append shared config to iframe URL", error);
      return iframeUrl;
    }
  }

  function buildShopifyShareUrl(payload) {
    const configId = payload?.configId ? String(payload.configId) : "";
    if (!configId) return "";
    const productHandle = normalizeProductHandle(payload?.productHandle);
    if (!productHandle) return "";
    const variantId = payload?.variantId ? String(payload.variantId) : "";
    const modelKey = payload?.modelKey ? String(payload.modelKey) : "";
    const size = payload?.size ? String(payload.size) : "";
    const productId = payload?.productId ? String(payload.productId) : "";

    const url = new URL(
      shopifyRoute(`products/${encodeURIComponent(productHandle)}`),
      window.location.origin,
    );
    url.searchParams.set("open_configurator", "1");
    url.searchParams.set("treedium_config", configId);
    url.searchParams.set("treedium_product", productHandle);
    if (modelKey) {
      url.searchParams.set("treedium_model", modelKey);
    }
    if (size) {
      url.searchParams.set("treedium_size", size);
    }
    if (productId) {
      url.searchParams.set("treedium_product_id", productId);
    }
    if (variantId) {
      url.searchParams.set("variant", variantId);
    } else {
      url.searchParams.delete("variant");
    }
    url.searchParams.delete("arConfig");
    url.searchParams.delete("d");
    url.hash = "";
    return url.toString();
  }

  function redirectToExpectedSharedProduct() {
    const params = new URLSearchParams(window.location.search);
    const expectedHandle = normalizeProductHandle(params.get("treedium_product"));
    if (!expectedHandle || !getSharedConfigIdFromPage()) return false;

    const productPathMatch = window.location.pathname.match(/\/products\/([^/?#]+)/i);
    const currentHandle = normalizeProductHandle(productPathMatch?.[1] || "");
    if (currentHandle === expectedHandle) return false;

    const redirectUrl = new URL(
      shopifyRoute(`products/${encodeURIComponent(expectedHandle)}`),
      window.location.origin,
    );
    redirectUrl.search = window.location.search;
    redirectUrl.hash = "";
    window.location.replace(redirectUrl.toString());
    return true;
  }

  function cleanupConfiguratorUrl(paramsToRemove) {
    const removableParams = Array.isArray(paramsToRemove) && paramsToRemove.length
      ? paramsToRemove.map((param) => String(param || "")).filter(Boolean)
      : [
        "variant",
        "open_configurator",
        "treedium_config",
        "treedium_product",
        "treedium_product_id",
        "treedium_model",
        "treedium_size",
      ];
    const url = new URL(window.location.href);
    let didChange = false;

    removableParams.forEach((param) => {
      if (url.searchParams.has(param)) {
        url.searchParams.delete(param);
        didChange = true;
      }
    });

    if (didChange) {
      window.history.replaceState(window.history.state, "", `${url.pathname}${url.search}${url.hash}`);
    }
  }

  function themeSectionsToUpdate() {
    return ["page-header", "cart-drawer"]
      .map((selector) => document.querySelector(selector))
      .filter(Boolean)
      .map((element) => ({
        element,
        id: element.dataset.sectionId,
      }))
      .filter((section) => section.id);
  }

  function ensurePreviewModal() {
    let modal = document.querySelector("[data-treedium-preview-modal]");
    if (modal) return modal;

    modal = document.createElement("div");
    modal.className = "treedium-preview-modal";
    modal.setAttribute("data-treedium-preview-modal", "");
    modal.setAttribute("role", "dialog");
    modal.setAttribute("aria-modal", "true");
    modal.hidden = true;
    modal.innerHTML = `
      <button class="treedium-preview-modal__close" type="button" aria-label="Close preview" data-treedium-preview-close>&times;</button>
      <img class="treedium-preview-modal__image" alt="Configured product preview" data-treedium-preview-image>
    `;
    document.body.appendChild(modal);

    return modal;
  }

  function openPreviewModal(imageUrl) {
    const modal = ensurePreviewModal();
    const image = modal.querySelector("[data-treedium-preview-image]");
    if (!image) return;

    image.setAttribute("src", imageUrl);
    modal.hidden = false;
    document.documentElement.classList.add("treedium-preview-open");
    document.body.classList.add("treedium-preview-open");
  }

  function closePreviewModal() {
    const modal = document.querySelector("[data-treedium-preview-modal]");
    if (!modal) return;

    const image = modal.querySelector("[data-treedium-preview-image]");
    if (image) image.removeAttribute("src");
    modal.hidden = true;
    document.documentElement.classList.remove("treedium-preview-open");
    document.body.classList.remove("treedium-preview-open");
  }

  function decoratePreviewAnchor(anchor, url) {
    if (!url) return;
    anchor.textContent = "Click Here";
    anchor.setAttribute("href", url);
    anchor.setAttribute("target", "_blank");
    anchor.setAttribute("rel", "noopener");
    anchor.setAttribute("data-treedium-preview-link", "");
  }

  function replacePreviewTextNodes(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        if (!parent || parent.closest("a, button, script, style, textarea")) {
          return NodeFilter.FILTER_REJECT;
        }
        return PREVIEW_URL_TEST_PATTERN.test(node.nodeValue || "")
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_REJECT;
      },
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach((node) => {
      const text = node.nodeValue || "";
      const fragment = document.createDocumentFragment();
      let lastIndex = 0;
      text.replace(PREVIEW_URL_PATTERN, (url, offset) => {
        fragment.append(document.createTextNode(text.slice(lastIndex, offset)));
        const anchor = document.createElement("a");
        decoratePreviewAnchor(anchor, url);
        fragment.append(anchor);
        lastIndex = offset + url.length;
        return url;
      });
      fragment.append(document.createTextNode(text.slice(lastIndex)));
      node.parentNode?.replaceChild(fragment, node);
    });
  }

  function decorateCartPreviewLinks() {
    CART_PREVIEW_ROOT_SELECTORS.forEach((selector) => {
      document.querySelectorAll(selector).forEach((root) => {
        root.querySelectorAll('a[href*="res.cloudinary.com"]').forEach((anchor) => {
          decoratePreviewAnchor(anchor, anchor.getAttribute("href"));
        });
        replacePreviewTextNodes(root);
      });
    });
  }

  document.addEventListener("click", (event) => {
    const closeButton = event.target.closest?.("[data-treedium-preview-close]");
    if (closeButton) {
      event.preventDefault();
      closePreviewModal();
      return;
    }

    const modal = event.target.closest?.("[data-treedium-preview-modal]");
    if (modal && event.target === modal) {
      closePreviewModal();
      return;
    }

    const previewLink = event.target.closest?.("[data-treedium-preview-link]");
    if (previewLink) {
      event.preventDefault();
      openPreviewModal(previewLink.getAttribute("href"));
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") closePreviewModal();
  });

  function findSectionTarget(id, parsed) {
    const exactTarget = document.getElementById(id);
    const exactSource = parsed.getElementById(id);
    if (exactTarget) return { target: exactTarget, source: exactSource };

    const tagTarget = document.querySelector(id);
    const tagSource = parsed.querySelector(id);
    if (tagTarget) return { target: tagTarget, source: tagSource };

    const sectionTarget = document.querySelector(`[id^="shopify-section"][id$="${id}"]`);
    const sectionSource = parsed.querySelector(`[id^="shopify-section"][id$="${id}"]`);
    if (sectionTarget) return { target: sectionTarget, source: sectionSource };

    return { target: null, source: null };
  }

  function applySections(sections, sectionIds = DRAWER_SECTION_IDS) {
    if (!sections || typeof sections !== "object") return;

    sectionIds.forEach((id) => {
      const html = sections[id];
      if (!html) return;

      const parsed = new DOMParser().parseFromString(html, "text/html");
      const { target, source } = findSectionTarget(id, parsed);
      if (target) {
        if (source && target.tagName === source.tagName) {
          target.replaceWith(source);
        } else {
          target.innerHTML = source ? source.innerHTML : html;
        }
      }
    });
    decorateCartPreviewLinks();
  }

  async function fetchSections(sectionIds) {
    const url = new URL(shopifyRoute("cart"), window.location.origin);
    url.searchParams.set("sections", sectionIds.join(","));
    const response = await fetch(url.toString(), { headers: { Accept: "application/json" } });
    return response.ok ? response.json() : null;
  }

  async function refreshCartUi() {
    try {
      const cart = await fetch(shopifyRoute("cart.js"), { headers: { Accept: "application/json" } }).then(
        (res) => (res.ok ? res.json() : null),
      );
      if (!cart) return null;

      const itemCount = Number(cart.item_count || 0);
      const countSelectors = [
        ".cart-count-bubble span",
        ".cart-count-bubble",
        "#cart-icon-bubble .visually-hidden",
        "[data-cart-count]",
      ];

      countSelectors.forEach((selector) => {
        document.querySelectorAll(selector).forEach((node) => {
          node.textContent = String(itemCount);
        });
      });

      document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart } }));
      document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { cart } }));
      document.dispatchEvent(new CustomEvent("theme:cart:change", { detail: { cart } }));
      window.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart } }));
      window.dispatchEvent(new CustomEvent("cart:refresh", { detail: { cart } }));
      window.dispatchEvent(new CustomEvent("theme:cart:change", { detail: { cart } }));
      decorateCartPreviewLinks();

      return cart;
    } catch (error) {
      console.error("Treedium cart refresh failed", error);
      return null;
    }
  }

  function normalizeOptionValue(value) {
    return String(value || "")
      .toLowerCase()
      .trim()
      .replace(/\s+/g, " ");
  }

  function modelSizeKey(modelKey, size) {
    const normalizedModelKey = normalizeOptionValue(modelKey).replace(/\s+/g, "-");
    const normalizedSize = normalizeOptionValue(size).replace(/\s+/g, "");
    return normalizedModelKey && normalizedSize ? `${normalizedModelKey}:${normalizedSize}` : "";
  }

  function getPayloadModelKey(payload) {
    return (
      payload?.selectedModelKey ||
      payload?.modelKey ||
      payload?.properties?._model_key ||
      payload?.properties?.modelKey ||
      ""
    );
  }

  function variantOptionValues(variant) {
    const values = [];
    if (Array.isArray(variant?.options)) values.push(...variant.options);
    ["option1", "option2", "option3"].forEach((key) => {
      if (variant?.[key]) values.push(variant[key]);
    });
    return values.map(normalizeOptionValue).filter(Boolean);
  }

  function getOptionName(option) {
    return normalizeOptionValue(
      typeof option === "string"
        ? option
        : option && typeof option === "object"
          ? option.name
          : "",
    );
  }

  function resolveSelectedColorFromVariant(productConfig) {
    if (productConfig?.selectedColor) {
      return productConfig.selectedColor;
    }

    const variants = Array.isArray(productConfig?.variants) ? productConfig.variants : [];
    const selectedVariant = variants.find((variant) => String(variant.id) === String(productConfig?.selectedVariantId));
    if (!selectedVariant || !Array.isArray(selectedVariant.options)) {
      return "";
    }

    const options = Array.isArray(productConfig?.options) ? productConfig.options : [];
    const colorOptionIndex = options.findIndex((option) => {
      const optionName = getOptionName(option);
      return optionName === "color" || optionName === "colour";
    });

    if (colorOptionIndex >= 0 && selectedVariant.options[colorOptionIndex]) {
      return selectedVariant.options[colorOptionIndex];
    }

    return selectedVariant.options.find((value) => !/\b\d+\s*ml\b/i.test(String(value || ""))) || "";
  }

  function applyLiveSelectedVariant(root, productConfig) {
    const productSection = root.closest(".js-product") || document;
    const variantInput =
      productSection.querySelector('.js-product-form [name="id"]') ||
      productSection.querySelector('form[action*="/cart/add"] [name="id"]') ||
      productSection.querySelector('[name="id"]');
    const urlVariantId = new URLSearchParams(window.location.search).get("variant");
    const liveVariantId = variantInput?.value || urlVariantId || "";
    const variants = Array.isArray(productConfig?.variants) ? productConfig.variants : [];
    const liveVariant = liveVariantId
      ? variants.find((variant) => String(variant.id) === String(liveVariantId))
      : null;

    if (!liveVariant) return productConfig;

    productConfig.selectedVariantId = liveVariant.id;
    productConfig.selectedVariantTitle = liveVariant.title || null;
    productConfig.selectedVariantAvailable = liveVariant.available ?? null;
    productConfig.selectedVariantPrice = liveVariant.price ?? null;
    productConfig.selectedColor = "";
    productConfig.selectedColor = resolveSelectedColorFromVariant(productConfig);

    return productConfig;
  }

  function productImpliedSizeValues(productConfig) {
    const values = [
      productConfig?.title,
      productConfig?.handle,
      productConfig?.configuratorData?.defaultSize,
      productConfig?.configuratorData?.size,
      productConfig?.size,
    ];
    return values
      .flatMap((value) => String(value || "").match(/\b\d+\s*ml\b/gi) || [])
      .map(normalizeOptionValue)
      .filter(Boolean);
  }

  function variantHasSizeValues(variants) {
    return variants.some((variant) => variantOptionValues(variant).some((value) => /\b\d+\s*ml\b/i.test(value)));
  }

  function availableVariantOptionValues(productConfig) {
    const variants = Array.isArray(productConfig?.variants) ? productConfig.variants : [];
    return Array.from(
      new Set(
        variants
          .filter((variant) => variant?.available !== false)
          .flatMap((variant) => variantOptionValues(variant))
          .filter(Boolean),
      ),
    );
  }

  function resolveVariantId(payload, productConfig) {
    if (payload.variantId) {
      const variants = Array.isArray(productConfig?.variants) ? productConfig.variants : [];
      const explicitVariant = variants.find((variant) => String(variant.id) === String(payload.variantId));
      if (!explicitVariant || explicitVariant.available !== false) {
        treediumLog("[Treedium Shopify] using explicit variantId from payload", payload.variantId);
        return payload.variantId;
      }
      treediumWarn("[Treedium Shopify] explicit variantId is no longer available", payload.variantId);
      return null;
    }

    const selectedSize = normalizeOptionValue(payload.selectedSize);
    const selectedColor = normalizeOptionValue(payload.selectedColor);
    const variants = Array.isArray(productConfig?.variants) ? productConfig.variants : [];

    if (selectedSize || selectedColor) {
      const impliedSizes = productImpliedSizeValues(productConfig);
      const hasVariantSizes = variantHasSizeValues(variants);
      const matchedVariant = variants.find((variant) => {
        const values = variantOptionValues(variant);
        const matchesSize =
          !selectedSize ||
          values.includes(selectedSize) ||
          impliedSizes.includes(selectedSize) ||
          !hasVariantSizes;
        const matchesColor = !selectedColor || values.includes(selectedColor);
        return matchesSize && matchesColor && variant.available !== false;
      });
      if (matchedVariant?.id) {
        treediumLog("[Treedium Shopify] matched selected options to variant", {
          selectedSize,
          selectedColor,
          impliedSizes,
          hasVariantSizes,
          variantId: matchedVariant.id,
          variantTitle: matchedVariant.title,
          variantOptions: variantOptionValues(matchedVariant),
        });
        return matchedVariant.id;
      }

      treediumWarn("[Treedium Shopify] no variant matched selected options; refusing fallback to page variant", {
        selectedSize,
        selectedColor,
        impliedSizes,
        hasVariantSizes,
        availableVariantOptions: variants.map((variant) => ({
          id: variant.id,
          title: variant.title,
          available: variant.available,
          values: variantOptionValues(variant),
        })),
      });
      return null;
    }

    const selectedVariant = variants.find((variant) => String(variant.id) === String(productConfig?.selectedVariantId));
    if (!selectedVariant || selectedVariant.available !== false) {
      treediumLog("[Treedium Shopify] no selected options provided; using page selected variant", productConfig?.selectedVariantId);
      return productConfig?.selectedVariantId;
    }
    const fallbackVariant = variants.find((variant) => variant?.available !== false);
    treediumLog("[Treedium Shopify] selected variant unavailable; using first available variant", fallbackVariant?.id);
    return fallbackVariant?.id || null;
  }

  function normalizeProductHandle(handleOrUrl) {
    const value = String(handleOrUrl || "").trim();
    if (!value) return "";

    const productPathMatch = value.match(/\/products\/([^/?#]+)/);
    if (productPathMatch?.[1]) return productPathMatch[1];

    return value
      .replace(/^https?:\/\/[^/]+\/products\//, "")
      .replace(/^\/?products\//, "")
      .replace(/^\/+|\/+$/g, "")
      .split(/[?#]/)[0];
  }

  async function resolveProductDefaultVariantId(productHandle) {
    const handle = normalizeProductHandle(productHandle);
    const handles = [handle, ...PERSONALIZATION_PRODUCT_FALLBACK_HANDLES]
      .filter(Boolean)
      .filter((item, index, array) => array.indexOf(item) === index);

    for (const productHandleToTry of handles) {
      const response = await fetch(shopifyRoute(`products/${encodeURIComponent(productHandleToTry)}.js`), {
        headers: { Accept: "application/json" },
      });
      if (!response.ok) continue;

      const product = await response.json();
      const variants = Array.isArray(product?.variants) ? product.variants : [];
      const variant = variants.find((item) => item?.available) || variants[0];
      if (variant?.id) return variant.id;
    }

    return null;
  }

  function normalizeProductConfig(product, familyEntry) {
    const variants = Array.isArray(product?.variants)
      ? product.variants.map((variant) => ({
          id: variant.id,
          title: variant.title,
          available: variant.available,
          price: variant.price,
          sku: variant.sku,
          options: variant.options,
          option1: variant.option1,
          option2: variant.option2,
          option3: variant.option3,
        }))
      : [];
    const selectedVariant = variants.find((variant) => variant.available !== false) || variants[0] || null;
    const selectedColor = Array.isArray(selectedVariant?.options)
      ? selectedVariant.options.find((value) => !/\b\d+\s*ml\b/i.test(String(value || ""))) || ""
      : "";

    return {
      productId: product?.id,
      handle: product?.handle || familyEntry.handle,
      title: product?.title,
      options: product?.options || [],
      variants,
      selectedVariantId: selectedVariant?.id || null,
      selectedVariantTitle: selectedVariant?.title || null,
      selectedVariantAvailable: selectedVariant?.available ?? null,
      selectedVariantPrice: selectedVariant?.price ?? null,
      selectedColor,
      configuratorData: {
        modelKey: familyEntry.modelKey,
        defaultSize: familyEntry.size,
      },
      modelKey: familyEntry.modelKey,
      size: familyEntry.size,
    };
  }

  async function fetchFamilyProductConfig(familyEntry, options = {}) {
    const handle = normalizeProductHandle(familyEntry.handle);
    if (!handle) return null;
    if (options.forceFresh) {
      productConfigPromiseCache.delete(handle);
    }
    if (!productConfigPromiseCache.has(handle)) {
      productConfigPromiseCache.set(
        handle,
        fetch(shopifyRoute(`products/${encodeURIComponent(handle)}.js`), {
          headers: { Accept: "application/json" },
        })
          .then((response) => (response.ok ? response.json() : null))
          .then((product) => (product ? normalizeProductConfig(product, familyEntry) : null))
          .catch((error) => {
            treediumWarn("[Treedium Shopify] failed to fetch family product", {
              handle,
              error,
            });
            return null;
          }),
      );
    }
    return productConfigPromiseCache.get(handle);
  }

  async function buildFamilyCatalog(productConfig, options = {}) {
    const products = await Promise.all(
      PRODUCT_FAMILY_HANDLES.map((familyEntry) => fetchFamilyProductConfig(familyEntry, options)),
    );
    const productsByModelSize = {};
    const handlesByModelSize = {};

    products.forEach((product, index) => {
      if (!product) return;
      const familyEntry = PRODUCT_FAMILY_HANDLES[index];
      const key = modelSizeKey(familyEntry.modelKey, familyEntry.size);
      if (!key) return;
      productsByModelSize[key] = product;
      handlesByModelSize[key] = familyEntry.handle;
    });

    const configuredCurrentModelKey =
      productConfig?.configuratorData?.modelKey || productConfig?.modelKey || "";
    const configuredCurrentSize =
      productConfig?.configuratorData?.defaultSize ||
      productConfig?.configuratorData?.size ||
      productConfig?.size ||
      "";
    const currentEntry =
      PRODUCT_FAMILY_HANDLES.find(
        (entry) => normalizeProductHandle(entry.handle) === normalizeProductHandle(productConfig?.handle),
      ) ||
      (configuredCurrentModelKey && configuredCurrentSize
        ? {
          modelKey: String(configuredCurrentModelKey),
          size: String(configuredCurrentSize),
          handle: String(productConfig?.handle || ""),
        }
        : null);
    if (currentEntry) {
      const currentKey = modelSizeKey(currentEntry.modelKey, currentEntry.size);
      const freshCurrentProduct = productsByModelSize[currentKey];
      productsByModelSize[currentKey] = {
        ...(freshCurrentProduct || {}),
        ...productConfig,
        variants: freshCurrentProduct?.variants || productConfig.variants,
        selectedVariantId: productConfig.selectedVariantId || freshCurrentProduct?.selectedVariantId,
        selectedVariantTitle: productConfig.selectedVariantTitle || freshCurrentProduct?.selectedVariantTitle,
        selectedVariantAvailable: productConfig.selectedVariantAvailable ?? freshCurrentProduct?.selectedVariantAvailable,
        selectedVariantPrice: productConfig.selectedVariantPrice ?? freshCurrentProduct?.selectedVariantPrice,
        selectedColor: productConfig.selectedColor || freshCurrentProduct?.selectedColor,
        modelKey: currentEntry.modelKey,
        size: currentEntry.size,
        configuratorData: {
          ...(productConfig.configuratorData || {}),
          modelKey: productConfig.configuratorData?.modelKey || currentEntry.modelKey,
          defaultSize: productConfig.configuratorData?.defaultSize || currentEntry.size,
        },
      };
      handlesByModelSize[currentKey] = currentEntry.handle;
    }

    treediumLog("[Treedium Shopify] resolved product family catalog", {
      handlesByModelSize,
      productKeys: Object.keys(productsByModelSize),
    });

    return {
      productsByModelSize,
      handlesByModelSize,
    };
  }

  function resolveTargetProductConfig(payload, productConfig) {
    const selectedModelKey = getPayloadModelKey(payload);
    const selectedSize = payload?.selectedSize || payload?.properties?._size || productConfig?.size || "";
    const key = modelSizeKey(selectedModelKey, selectedSize);
    const targetProduct = key && productConfig?.productsByModelSize?.[key];
    if (targetProduct) {
      treediumLog("[Treedium Shopify] using selected family product", {
        key,
        handle: targetProduct.handle,
        selectedModelKey,
        selectedSize,
      });
      return targetProduct;
    }
    treediumWarn("[Treedium Shopify] no selected family product found; using opened page product", {
      key,
      selectedModelKey,
      selectedSize,
      availableProductKeys: Object.keys(productConfig?.productsByModelSize || {}),
    });
    return productConfig;
  }

  function postAddToCartResult(targetWindow, allowedOrigin, requestId, result) {
    if (!targetWindow || typeof targetWindow.postMessage !== "function") return;
    const payload = {
      type: MESSAGE_TYPE_ADD_RESULT,
      requestId: requestId || "",
      ...result,
    };
    try {
      targetWindow.postMessage(payload, allowedOrigin || "*");
    } catch (error) {
      console.warn("[Treedium Shopify] add-to-cart response postMessage failed; retrying with wildcard", error);
      targetWindow.postMessage(payload, "*");
    }
  }

  async function addToCart(items) {
    try {
      treediumLog("[Treedium Shopify] adding cart items", items);
      const cartUi = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
      const isNotificationUi = cartUi && cartUi.tagName.toLowerCase() === "cart-notification";
      const themeSections = themeSectionsToUpdate();
      const themeSectionIds = themeSections.map((section) => section.id);
      const fallbackSectionIds = Array.from(
        new Set([...(isNotificationUi ? NOTIFICATION_SECTION_IDS : []), ...DRAWER_SECTION_IDS]),
      );
      const sectionIds = themeSectionIds.length ? themeSectionIds : fallbackSectionIds;

      const response = await fetch(cartRoute("cartAdd", "cart/add.js"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          items,
          sections: sectionIds.join(","),
          sections_url: `${window.location.pathname}${window.location.search}`,
        }),
      });

      let result = null;
      try {
        result = await response.json();
      } catch (error) {
        treediumWarn("[Treedium Shopify] cart/add response was not JSON", error);
      }
      treediumLog("[Treedium Shopify] cart/add response", {
        ok: response.ok,
        status: response.status,
        result,
      });

      if (!response.ok) {
        throw new Error(result?.description || result?.message || "Could not add item to cart");
      }

      Promise.resolve()
        .then(async () => {
          if (cartUi && typeof cartUi.renderContents === "function") {
            try {
              cartUi.renderContents(result);
            } catch (error) {
              console.warn("Treedium cart renderContents failed", error);
            }
          }

          if (result?.sections && themeSections.length) {
            try {
              themeSections.forEach(({ element, id }) => {
                if (result.sections[id] && typeof element.updateFromCartChange === "function") {
                  element.updateFromCartChange(result.sections[id]);
                }
              });
            } catch (error) {
              console.warn("Treedium cart section update failed", error);
            }
          } else if (result && result.sections) {
            try {
              applySections(result.sections, sectionIds);
            } catch (error) {
              console.warn("Treedium cart section apply failed", error);
            }
          }

          try {
            const freshSections = await fetchSections(sectionIds);
            if (freshSections && themeSections.length) {
              themeSections.forEach(({ element, id }) => {
                if (freshSections[id] && typeof element.updateFromCartChange === "function") {
                  element.updateFromCartChange(freshSections[id]);
                }
              });
            } else if (freshSections) {
              applySections(freshSections, sectionIds);
            }
          } catch (error) {
            console.warn("Treedium fresh cart sections failed", error);
          }

          await refreshCartUi();

          try {
            const drawer = document.querySelector(".js-cart-drawer") || document.querySelector("cart-drawer");
            if (drawer) {
              drawer.classList.remove("is-empty");
              const drawerInner = drawer.querySelector(".drawer__inner");
              if (drawerInner) drawerInner.classList.remove("is-empty");
              const drawerItems = drawer.querySelector("cart-drawer-items");
              if (drawerItems) drawerItems.classList.remove("is-empty");
            }
          } catch (error) {
            console.warn("Treedium cart drawer state update failed", error);
          }
        })
        .catch((error) => {
          console.warn("Treedium async cart refresh failed", error);
        });

      return true;
    } catch (error) {
      console.error("[Treedium Shopify] add-to-cart failed after cart/add attempt", {
        error,
        message: error?.message,
        stack: error?.stack,
      });
      return false;
    }
  }

  function normalizeProperties(payload) {
    const properties =
      payload.properties && typeof payload.properties === "object" && !Array.isArray(payload.properties)
        ? { ...payload.properties }
        : {};
    if (payload.summary) {
      properties.Configuration = String(payload.summary);
    }
    if (payload.configId) {
      properties._config_id = String(payload.configId);
    }
    if (payload.family) {
      properties._config_family = String(payload.family);
    }
    return properties;
  }

  if (redirectToExpectedSharedProduct()) return;

  blocks.forEach((root) => {
    const button = root.querySelector("[data-open-configurator]");
    const modal = root.querySelector("[data-modal]");
    const iframe = root.querySelector("[data-config-iframe]");
    const closeButtons = root.querySelectorAll("[data-close-modal]");

    if (!button || !modal || !iframe) return;

    const iframeUrl = button.getAttribute("data-iframe-url");
    const allowedOriginRaw = button.getAttribute("data-allowed-origin") || "";
    const allowedOrigin = allowedOriginRaw.replace(/\/+$/, "");
    const defaultQuantity = Math.max(1, Number(button.getAttribute("data-default-quantity") || "1"));
    const personalizationProductHandle = button.getAttribute("data-personalization-product-handle") || "";
    const configScriptId = button.getAttribute("data-config-script-id");

    function getAnalyticsConsentState() {
      const customerPrivacy = window.Shopify?.customerPrivacy;
      const analyticsAllowed =
        typeof customerPrivacy?.analyticsProcessingAllowed === "function"
          ? customerPrivacy.analyticsProcessingAllowed() === true
          : false;
      const visitorConsent =
        typeof customerPrivacy?.currentVisitorConsent === "function"
          ? customerPrivacy.currentVisitorConsent()
          : null;
      const analyticsConsent = visitorConsent?.analytics;

      return {
        analyticsAllowed,
        explicitAnalyticsConsent:
          analyticsConsent === "yes" ? true : analyticsConsent === "no" ? false : null,
      };
    }

    function sendAnalyticsConsentToIframe() {
      if (!iframe.contentWindow) return;
      iframe.contentWindow.postMessage(
        {
          type: MESSAGE_TYPE_ANALYTICS_CONSENT,
          ...getAnalyticsConsentState(),
        },
        allowedOrigin || "*"
      );
    }

    function readProductConfig() {
      if (!configScriptId) return null;
      const script = document.getElementById(configScriptId);
      if (!script) return null;
      try {
        return JSON.parse(script.textContent || "{}");
      } catch (error) {
        console.error("Invalid product config JSON", error);
        return null;
      }
    }

    let familyCatalogPromise = null;

    async function sendInitMessageToIframe() {
      const productConfig = readProductConfig();
      if (!productConfig || !iframe.contentWindow) return;
      applyLiveSelectedVariant(root, productConfig);
      productConfig.selectedColor = resolveSelectedColorFromVariant(productConfig);
      if (!familyCatalogPromise) familyCatalogPromise = buildFamilyCatalog(productConfig);
      const familyCatalog = await familyCatalogPromise;
      const hydratedProductConfig = {
        ...productConfig,
        ...familyCatalog,
      };

      const initPayload = {
        type: MESSAGE_TYPE_INIT,
        productConfig: hydratedProductConfig,
      };
      treediumLog("[Treedium Shopify] sending TREEDIUM_INIT_CONFIG", {
        targetOrigin: allowedOrigin || "*",
        payload: initPayload,
      });

      iframe.contentWindow.postMessage(initPayload, allowedOrigin || "*");
      sendAnalyticsConsentToIframe();
    }

    function closeModal() {
      modal.hidden = true;
      iframe.removeAttribute("src");
      document.documentElement.classList.remove("treedium-modal-open");
      document.body.classList.remove("treedium-modal-open");
      stopShopifyChatSuppression();
    }

    function openModal() {
      if (!iframeUrl) {
        treediumWarn("[Treedium Shopify] missing configurator URL");
        return;
      }
      modal.hidden = false;
      iframe.setAttribute("src", buildConfiguratorIframeUrl(iframeUrl));
      iframe.addEventListener("load", sendInitMessageToIframe, { once: true });
      iframe.addEventListener("load", sendAnalyticsConsentToIframe, { once: true });
      window.setTimeout(sendAnalyticsConsentToIframe, 250);
      window.setTimeout(sendAnalyticsConsentToIframe, 1000);
      document.documentElement.classList.add("treedium-modal-open");
      document.body.classList.add("treedium-modal-open");
      startShopifyChatSuppression();
    }

    async function handleMessage(event) {
      treediumLog("[Treedium Shopify] received postMessage", {
        origin: event.origin,
        allowedOrigin,
        data: event.data,
      });

      if (!allowedOrigin) {
        treediumWarn("[Treedium Shopify] missing allowed origin");
        return;
      }

      const eventOrigin = String(event.origin || "").replace(/\/+$/, "");
      if (eventOrigin !== allowedOrigin) {
        treediumWarn("[Treedium Shopify] ignored postMessage from unexpected origin", {
          eventOrigin,
          allowedOrigin,
          data: event.data,
        });
        return;
      }

      const data = event.data;
      if (!data || typeof data !== "object") {
        treediumWarn("[Treedium Shopify] ignored invalid message payload", data);
        return;
      }

      if (data.type === MESSAGE_TYPE_CLOSE) {
        cleanupConfiguratorUrl(data.params);
        closeModal();
        return;
      }

      if (data.type === MESSAGE_TYPE_CLEAN_URL) {
        cleanupConfiguratorUrl(data.params);
        return;
      }

      if (data.type === MESSAGE_TYPE_READY) {
        sendInitMessageToIframe();
        return;
      }

      if (data.type === MESSAGE_TYPE_ANALYTICS_CONSENT_REQUEST) {
        sendAnalyticsConsentToIframe();
        return;
      }

      if (data.type === MESSAGE_TYPE_SHARE_REQUEST) {
        const shareUrl = buildShopifyShareUrl(data);
        if (iframe.contentWindow) {
          iframe.contentWindow.postMessage(
            {
              type: MESSAGE_TYPE_SHARE_RESPONSE,
              requestId: data.requestId || "",
              url: shareUrl,
            },
            allowedOrigin || "*"
          );
        }
        treediumLog("[Treedium Shopify] resolved share URL", {
          payload: data,
          url: shareUrl,
        });
        return;
      }

      if (data.type !== MESSAGE_TYPE_ADD) {
        return;
      }

      const requestId = data.requestId || "";
      const responseWindow = event.source || iframe.contentWindow;
      try {
        const productConfig = readProductConfig();
        const familyCatalog = await buildFamilyCatalog(productConfig, { forceFresh: true });
        const hydratedProductConfig = {
          ...productConfig,
          ...familyCatalog,
        };
        const targetProductConfig = resolveTargetProductConfig(data, hydratedProductConfig);
        const variantId = resolveVariantId(data, targetProductConfig);
        const quantity = Math.max(1, Number(data.quantity || defaultQuantity));
        treediumLog("[Treedium Shopify] resolved cart request", {
          payload: data,
          productConfig: hydratedProductConfig,
          targetProductConfig,
          variantId,
          quantity,
        });
        if (!variantId) {
          postAddToCartResult(responseWindow, allowedOrigin, requestId, {
            ok: false,
            reason: "variant_unavailable",
            message: "Selected color is no longer available.",
            availableColors: availableVariantOptionValues(targetProductConfig),
          });
          return;
        }

        const properties = normalizeProperties(data);
        const personalizationQuantity = Math.max(0, Number(data.personalizationQuantity || 0));
        const personalizationVariantId =
          personalizationQuantity > 0
            ? await resolveProductDefaultVariantId(personalizationProductHandle)
            : null;
        if (personalizationQuantity > 0 && !personalizationVariantId) {
          postAddToCartResult(responseWindow, allowedOrigin, requestId, {
            ok: false,
            reason: "personalization_product_unavailable",
            message: "Personalization could not be added. Please try again.",
            availableColors: availableVariantOptionValues(targetProductConfig),
          });
          return;
        }

        const configId = data.configId ? String(data.configId) : "";
        const items = [
          {
            id: Number(variantId),
            quantity,
            properties,
          },
        ];

        if (personalizationQuantity > 0) {
          const personalizationProperties = {};
          if (configId) personalizationProperties._config_id = configId;
          if (properties._cart_group_id) personalizationProperties._cart_group_id = String(properties._cart_group_id);
          personalizationProperties._personalization_for = String(variantId);

          items.push({
            id: Number(personalizationVariantId),
            quantity: personalizationQuantity,
            properties: personalizationProperties,
          });
        }

        const didAdd = await addToCart(items);
        if (!didAdd) {
          postAddToCartResult(responseWindow, allowedOrigin, requestId, {
            ok: false,
            reason: "cart_add_failed",
            message: "We could not add this item to cart. Please try again.",
            availableColors: availableVariantOptionValues(targetProductConfig),
          });
          return;
        }
        cleanupConfiguratorUrl();
        treediumLog("[Treedium Shopify] configured add-to-cart succeeded; replying to iframe", { requestId });
        postAddToCartResult(responseWindow, allowedOrigin, requestId, { ok: true });
      } catch (error) {
        console.error("[Treedium Shopify] configured add-to-cart handler failed", error);
        postAddToCartResult(responseWindow, allowedOrigin, requestId, {
          ok: false,
          reason: "cart_add_error",
          message: "We could not add this item to cart. Please try again.",
        });
      }
    }

    button.addEventListener("click", openModal);
    closeButtons.forEach((closeBtn) => closeBtn.addEventListener("click", closeModal));
    window.addEventListener("message", handleMessage);
    document.addEventListener("visitorConsentCollected", sendAnalyticsConsentToIframe);

    if (!didAutoOpenSharedConfigurator && shouldAutoOpenConfigurator()) {
      didAutoOpenSharedConfigurator = true;
      window.setTimeout(openModal, 250);
    }
  });

  decorateCartPreviewLinks();
})();
